import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const useToken = () => {
const dispatch = useDispatch()
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isAuthenticated") === "true"
  );
  
  // initialise Authentication

  useEffect(() => {
    // Check for token in localStorage on app load
    const token = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  // Retrieve the token from localStorage or initialize it as null
  const getToken = () => {
    return sessionStorage.getItem("authToken") || localStorage.getItem("authToken");;
  };

  const [token, setTokenState] = useState(getToken());

  // Function to save token in localStorage and update state
  const setToken = (userToken) => {
    sessionStorage.setItem("authToken", userToken);
    setTokenState(userToken);
  };

  // Function to remove the token (e.g., on logout)
  const removeToken = () => {
    sessionStorage.removeItem("authToken");
    dispatch({ type: 'LOGOUT' });
    setTokenState(null);
  };

  

  const login = (accessToken, rememberMe,refreshToken) => {
    setIsAuthenticated(true);
    localStorage.setItem("isAuthenticated", "true");
    if (rememberMe) {
      localStorage.setItem("authToken", accessToken);
      sessionStorage.setItem("authToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      sessionStorage.setItem("refreshToken", refreshToken);
       // Store token in localStorage
    } else {
      sessionStorage.setItem("authToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      sessionStorage.setItem("refreshToken", refreshToken);
    }
    setTokenState(accessToken);
  };
  
  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("isAuthenticated");
    localStorage.clear();
    sessionStorage.clear();
    dispatch({ type: 'LOGOUT' });
  };

  return { token, setToken, getToken, removeToken, login, logout, setIsAuthenticated, isAuthenticated };
};

export default useToken;